import aliprintLogo from '../images/partners/aliprint_logo.png';
import beelineLogo from '../images/partners/beeline_logo.png';
import crafersLogo from '../images/partners/crefers_logo.png';
import evosLogo from '../images/partners/evos_logo.png';
import mediaparkLogo from '../images/partners/mediapark_logo.png';
import mirhayatLogo from '../images/partners/mirhayat_logo.png';
import nmedovLogo from '../images/partners/nmedov_logo.png';
import paynetLogo from '../images/partners/paynet_logo.png';

const partners = [
  {
    image: aliprintLogo,
  },
  {
    image: beelineLogo,
  },
  {
    image: crafersLogo,
  },
  {
    image: evosLogo,
  },
  {
    image: mediaparkLogo,
  },
  {
    image: mirhayatLogo,
  },
  {
    image: nmedovLogo,
  },
  {
    image: paynetLogo,
  },
];

export default partners;
